const initialState = {
  clientFacing: "",
};

const signatureType = (state = initialState, action) => {
  switch (action.type) {
    case "ON_SIGNATURE_TYPE_SELECT":
      return {
        ...state,
        clientFacing: action.value
      };

    default:
      return state;
  }
};

export default signatureType;



// WEBPACK FOOTER //
// ./src/reducers/signature-type.js